'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$100() {
  this.bAn = null;
  this.bAo = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$100 as $c_Lpresto_TwoFactorAuthView$$anon$100 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$100.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$100;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$100() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$100 as $h_Lpresto_TwoFactorAuthView$$anon$100 };
$h_Lpresto_TwoFactorAuthView$$anon$100.prototype = $p;
$p.P = (function() {
  if ((!this.bAo)) {
    this.bAn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T4($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bAo = true;
  }
  return this.bAn;
});
var $d_Lpresto_TwoFactorAuthView$$anon$100 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$100, "presto.TwoFactorAuthView$$anon$100", ({
  Se: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$100 as $d_Lpresto_TwoFactorAuthView$$anon$100 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$100.js.map
